<template>
  <div class="archive-page">
    <div class="archive-select archive-box">
      <div class="archive-title">
        测评记录查询
      </div>
      <div class="archive-from">
        <el-input v-model="account" style="width:50%" placeholder="输入学生账号"></el-input>
        <el-button class="archive-btn" type="primary" :loading="loading" @click="tableList">搜 索</el-button>
      </div>
    </div>
    <div class="archive-list" v-if="isStudent">
      <div class="archive-box person-box" :class="`person-sex${userList.sex}`">
        <div class="person-title">
          <p :class="`sex${userList.sex}`">{{ userList.real_name }}</p>
        </div>
        <ul class="person-info">
          <li>
            <span>账号：</span>
            <p>{{ userList.t_id }}</p>
          </li>
          <li>
            <span>民族：</span>
            <p>{{ userList.nation_title }}</p>
          </li>
          <li>
            <span>生日：</span>
            <p>{{ userList.birthday }}</p>
          </li>
        </ul>
      </div>
      <div class="archive-box report-list" v-for="item in tableData" :key="item.id">
        <div class="report-title">
          {{ item.title }}
          <span :class="'report-level level' + item.question_id">{{ item.question }}</span>
        </div>
        <template v-if="item.report_type_2024 == 2">
          <div class="report-content">
            <h2>{{ item.batch }}<el-tag type="warning">复检</el-tag>
              <p>{{
          item.start_time }}</p>
            </h2>
            <el-button plain @click="viewRecheckReport(item)">查看报告</el-button>
          </div>
        </template>
        <template v-else>
          <div class="report-content">
            <h2>{{ item.sub_list[0].title }}<el-tag>普测</el-tag>
              <p>{{
          item.start_time }}</p>
            </h2>
            <el-button plain @click="viewReport(item)">查看报告</el-button>
          </div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import { APIRECORDINFO } from "@/common/api.js"
import downloadApi from "@/common/downloadApi"
import { getStorage } from "@/common/storage"

export default {
  name: "Archive",
  data() {
    return {
      Api: downloadApi,
      account: "",
      tableData: [],
      userList: {
        sex: "",
        real_name: "",
        t_id: "",
        birthday: "",
        nation_title: "",
      },
      userInfo: getStorage('USERINFO'),
      isStudent: false,
      loading: false,
    }
  },

  methods: {
    tableList() { // 表格
      this.loading = true
      APIRECORDINFO({
        account: this.account
      }).then((res) => {
        this.loading = false
        this.isStudent = true
        this.userList = res.data.user_info
        this.tableData = res.data.list
      }).catch((err) => {
        this.loading = false
        this.isStudent = false
        this.$message.error(err.msg)
      })
    },

    viewReport(val) {
      let hrefStr = ''
      if (val.edition === 'v2') {
        hrefStr = '#/personreport'
      } else if (val.edition === 'v4') {
        hrefStr = 'api/report/getRecommendIndividualReportByV4'
      } else if (val.edition === 'v5') {
        hrefStr = 'api/report/getRecommendIndividualReportByV5'
      } else {
        hrefStr = 'api/report/getRecommendIndividualReportView'
      }
      // 新窗口打开报告链接
      window.open(`${this.Api}${hrefStr}?report_id=${val.id}&sid=${val.sub_list[0].id}&token=${this.userInfo.bms_token}&semester_start_time=${val.db_time}`, "_blank")
    },
    // 复检报告
    viewRecheckReport(val) {
      window.open(`${this.Api}api/report/getDownRecheckReportIndividualView?report_id=${val.recheck_id}&token=${this.userInfo.bms_token}&semester_start_time=${val.db_time}`, "_blank"
      );
    }
  }
}

</script>

<style lang="scss" scoped>
.archive-page {
  max-width: 1024px;
  margin: 0 auto;

  .archive-box {
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(143, 143, 143, 0.2);
    border-radius: 10px;
  }

  .archive-select {
    margin-top: 10px;
    padding: 30px 40px;

    .archive-title {
      font-weight: bold;
      font-size: 20px;
      color: #17233D;
      line-height: 26px;
      text-align: left;
      font-style: normal;
    }

    .archive-from {
      display: flex;
      margin-top: 10px;
      justify-content: space-between;

      .archive-btn {
        background: #4C5BF7;
        border-color: #4C5BF7;
        width: 30%;
        max-width: 100px;
      }
    }
  }

  .archive-list {
    margin-bottom: 30px;
  }

  .person-box {
    margin-top: 10px;
    padding: 40px 40px 40px 160px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      left: 40px;
      top: 40px;
      height: 80px;
      width: 80px;
    }

    &.person-sex1::before {
      background: url(../../assets/image/person1.png) no-repeat top left;
      background-size: 80px 80px;
    }

    &.person-sex2::before {
      background: url(../../assets/image/person2.png) no-repeat top left;
      background-size: 80px 80px;
    }
  }


  .person-title {
    margin-top: 0;
    display: flex;
    justify-content: flex-start;
    line-height: 30px
  }

  .person-title p {
    font-size: 20px;
    color: #17233D;
    font-weight: bold;
  }

  .person-title .sex1::after {
    content: "";
    width: 20px;
    height: 30px;
    margin-left: 10px;
    display: inline-block;
    background: url(../../assets/image/icon-boy.png) no-repeat center;
    background-size: contain;
    vertical-align: middle;
  }

  .person-title .sex2::after {
    content: "";
    width: 20px;
    height: 30px;
    margin-left: 10px;
    display: inline-block;
    background: url(../../assets/image/icon-girl.png) no-repeat center;
    background-size: contain;
    vertical-align: middle;
  }

  .person-info {
    margin-top: 20px;
    overflow: hidden;
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }

  .person-info li {
    margin-right: 40px;
    padding-right: 40px;
    border-right: 1px solid #ccc;

    &:last-child {
      border-right: none;
    }

    span {
      margin-right: 10px;
    }

    p {
      font-size: 14px;
      color: #17233D;
      display: inline-block;

    }
  }

  .person-info li span {
    font-size: 14px;
    color: #999
  }

  .report-list {
    margin-top: 10px;
    padding: 20px 30px 30px;

    .report-title {
      font-size: 16px;
      color: #17233D;
      display: flex;
      justify-content: space-between;
      border-bottom: #E6E6E6 2px solid;
      line-height: 30px;
      padding-bottom: 10px;

      span {
        font-weight: bold;
        font-size: 18px;

        &.level4 {
          color: #F95860;
        }

        &.level3 {
          color: #EFA312;
        }

        &.level2 {
          color: #039FF1;
        }

        &.level1 {
          color: #36C073;
        }

        &.level5 {
          color: #666;
        }
      }
    }

    .report-content {
      display: flex;
      margin-top: 20px;
      justify-content: space-between;
      align-items: center;

      h2 {
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        color: #17233D;

        .el-tag {
          margin-left: 10px;
          vertical-align: middle;
        }

        p {
          font-size: 14px;
          color: #666666;
          line-height: 14px;
          font-weight: normal;
          margin-top: 10px;
          display: block;
        }
      }

      .el-button {
        border-radius: 8px;
        border: 2px solid #4C5BF7;
        font-weight: bold;
        font-size: 18px;
        color: #4C5BF7;
      }
    }
  }

}

@media (max-width: 790px) {
  .archive-page {
    .person-info {
      display: block;

      li {
        border: none;
        padding: 0;
        margin: 0 0 10px 0;
      }

    }
  }
}
</style>